/**
 * What is Citizen Web's own on the shared account screens (@tonnie/account):
 * its brand panel, its language picker, and where a finished sign-in or
 * sign-up goes — a satellite's `redirect_url` (the Clerk handshake back to
 * Business Web), else InOut when a portal's calculator handed a calculation
 * over in this tab (InOut adopts it — whichever way the person signed in),
 * else the dashboard. Mounted once in App.tsx.
 */
import type { AccountPortalConfig } from '@tonnie/account';
import { TONNIE_LEGAL_URLS } from '@tonnie/foundation';

import { LanguageSelector } from '@/components/ui/LanguageSelector';
import { featureFlags } from '@/core/config/feature-flags';

import { cameFromCalculator } from '@/features/heroes/inout/lib/pending-handoff';

import { readPostAuthRedirect } from './utils/post-auth-redirect';

/**
 * Where a session goes, short of a satellite's redirect: a finished sign-in or
 * sign-up, and a person already signed in who opens /signup.
 */
export const citizenHome = () => (cameFromCalculator() ? '/inout' : '/dashboard');

export const CITIZEN_ACCOUNT_PORTAL: AccountPortalConfig = {
  portal: 'citizen',
  languageSelector: <LanguageSelector showLabel />,
  afterSignIn: () => readPostAuthRedirect() ?? citizenHome(),
  afterSignUp: () => readPostAuthRedirect() ?? citizenHome(),
  legal: TONNIE_LEGAL_URLS,
  securitySettingsPath: '/settings?tab=security',
  allowTotp: featureFlags.ENABLE_2FA,
};
